import { render } from "./AssetViewDetail.vue?vue&type=template&id=6118e39f"
import script from "./AssetViewDetail.vue?vue&type=script&lang=js"
export * from "./AssetViewDetail.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\pa-health-connect\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__